<template>
    <div v-bind:class="rowClass">
        <div class="label" v-if="label">{{ label }}</div>
        <div class="value" v-if="valueType == 'text'" v-html="htmlValue"></div>
        <div class="value" v-if="valueType == 'timestamp'">{{ timestampValue }}</div>
        <div class="value" v-if="valueType == 'string' || valueType == 'phone'" v-html="htmlValue"></div>
        <div class="value" v-if="valueType == 'elevation'">{{ elevationText }}</div>
        <div class="value" v-if="valueType == 'distance'">{{ distanceText }}</div>
        <div class="value" v-if="valueType == 'url'"><a v-bind:href="hrefText" target="_blank">{{ value }}</a></div>
        <div class="value" v-if="valueType == 'email'"><a v-bind:href="emailText" target="_blank">{{ value }}</a></div>
    </div>
</template>

<script>
import * as moment from 'moment';
export default {
    name: "VSLLabelRowRenderer",
    props: {
        label: String,
        value: null,
        valueType: {type: String, default: () => 'text'}
    },

    computed: {
        rowClass() {
            return this.label ? "vsl-row vsl-label-row vsl-label-row-grid" : "vsl-row vsl-label-row";
        },

        htmlValue() {
            return this.value ? this.value.toString() : ""
        },

        timestampValue() {
          return moment(this.value).format("YYYY-MM-DD hh:mm");
        },

        hrefText() {
            return !this.value || this.value.indexOf("http") == 0 ? this.value : "http://" + this.value;
        },

        emailText() {
            return !this.value ? this.value : "mailto:" + this.value;
        },

        distanceText() {
            return this.value ? (this.value / 1000) + " km" : "";
        },

        elevationText() {
            return this.value ? this.value + " m" : "";
        }
    }
}
</script>

<style>
.vsl-label-row {
    max-width: 100%;
    width: 100%;
    font-size: 11px;
}

.vsl-label-row-grid {
    display: grid;
    grid-template-columns: 30% 70%;
    justify-content: left;
    column-gap: 8px;
}

.label {
    display: inline-block;
    max-width: 300px;
    text-align: left;
    vertical-align: top;
}

.value {
    display: inline-block;
    max-width: 100%;
    text-align: left;
    vertical-align: top;
}

.value a {
    white-space: pre-wrap; /* CSS3 */    
    white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
    white-space: -pre-wrap; /* Opera 4-6 */    
    white-space: -o-pre-wrap; /* Opera 7 */    
    word-wrap: break-word;
}

.value p a {
    word-wrap: break-word;
}
</style>
